import { useQuery } from "react-query";
import http from "infra/http";
import { AxiosError } from "axios";
import { OrcamentoCotacaoItemForm } from 'features/orcamento/typings';

export function useDetalhesItemCotacao(id?: string,cotacaoId?:string) {
  return useQuery<OrcamentoCotacaoItemForm, AxiosError>(
    `/v1/orcamento/${id}/cotacao/${cotacaoId}`,
    async () => {
      const { data } = await http.get<OrcamentoCotacaoItemForm>(
        `/v1/orcamento/${id}/cotacao/${cotacaoId}`
      );

      return data;
    },
    { enabled: !!id && !!cotacaoId}
  );
}
